module.exports = __webpack_public_path__ + "img/bus.5dcfd076.jpg";